import React, { useEffect, useState } from "react";
import ModalImage from "react-modal-image";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../Axios/api";
import Select from "react-select";
import Swal from "sweetalert2";
import { Trash2 } from "lucide-react";
import { useSelector } from "react-redux";
const MaterialForm = () => {
  const Branch = useSelector((state) => state.user.staff_FacLoc);
  const UserName = useSelector((state) => state.user.staff_name);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [facName, setFacName] = useState("");
  const [facLocation, setFacLocation] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [itemGroups, formDataGroups] = useState([]);
  const [dropItem, setDropItems] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [editData, setEditData] = useState(null);
  const [editDataId, setEditDataId] = useState(null);
  const [formData, setFormData] = useState({
    factory: "",
    party: "",
    entryDate: "",
    voucherNo: "",
    challanDate: "",
    challanNo: "",
    destination: "",
    dispathThrough: "",
    deliveryTerms: "",
    narration: "",
    invoice_img: "",
  });

  const [item, setItem] = useState({
    item_name: "",
    item_unit: "",
    item_group: "",
    item_desc: "",
    item_gst: "",
    item_qty: "",
    item_rate: "",
  });
  useEffect(() => {
    const editDataMode = location.state?.userData !== undefined;
    if (editDataMode) {
      setEditData(location.state.userData);
    }
  }, [location.state]);

  const getCategory = () => {
    api
      .get(`/purchase-item-category/get-name`)
      .then((res) => {
        const data = res.data;
        const newData = data.map((cat, index) => {
          let value = cat._id + "_" + cat.itemcat_title;
          return { value: value, label: cat.itemcat_title };
        });
        formDataGroups(newData);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getItems = async (catId) => {
    if (catId === "") {
      setDropItems([]);
      return;
    }

    try {
      let url = "";
      if (UserName === "Admin" || UserName === "Sameer Khan") {
        url = `/purchase-item/get-item-by-catloc/?catId=${catId}&factory=${formData.factory}`;
      } else {
        url = `/purchase-item/get-item-by-catloc/?catId=${catId}&factory=${Branch}`;
      }
      const res = await api.get(url);
      const data = res.data;
      const newData = data.map((item) => {
        let value = item._id + "_" + item.item_title;
        return { value: value, label: item.item_title, unit: item.item_unit };
      });
      setDropItems(newData);
    } catch (error) {
      console.error("Error fetching group items:", error);
    }
  };

  const getVenderList = async () => {
    await api
      .get(`/vendor/get-name`)
      .then((res) => {
        const newData = res.data.map((vendor, index) => {
          return { value: vendor._id, label: vendor.vendor_name };
        });
        setVendorList(newData);
      })
      .catch((err) => console.log(err));
  };
  const facLocHandler = async () => {
    await api
      .get(`/factory-location/get-factory-location`)
      .then((res) => {
        const newData = res.data.map((location) => ({
          value: location._id,
          label: location.fectory_loca_name,
        }));
        setFacLocation(newData);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    facLocHandler();
    getVenderList();
    getCategory();
    if (Branch === "666c0f5ebeca5ab2c65b2c86") {
      setFacName("POLYBOND PROJECTS");
    } else if (Branch === "666c0f5ebeca5ab2c65b2c87") {
      setFacName("POLYBOND ROCKFIBRE");
    } else {
      setFacName("POLYBOND INSULATION");
    }
    if (!(UserName === "Admin" || UserName === "Sameer Khan")) {
      setFormData((prev) => ({
        ...prev,
        factory: Branch,
      }));
    }
  }, []);

  useEffect(() => {
    getItems(item.item_group.split("_")[0]);
  }, [item.item_group, formData.factory]);

  useEffect(() => {
    if (editData) {
      setFormData({
        factory: editData.factory || "",
        party: editData.party || "",
        entryDate: editData.entryDate,
        voucherNo: editData.voucherNo || "",
        challanDate: editData.challanDate,
        challanNo: editData.challanNo || "",
        destination: editData.destination || "",
        dispathThrough: editData.dispathThrough || "",
        deliveryTerms: editData.deliveryTerms || "",
        narration: editData.narration || "",
        invoice_img: editData.invoice_img || "",
      });

      setItemList(editData.items || []);
      setEditDataId(editData._id);
    }
  }, [editData]);

  const handleChange = (e, actionMeta) => {
    if (actionMeta) {
      const { name } = actionMeta;
      setFormData((prev) => ({
        ...prev,
        [name]: e.value,
      }));
    } else {
      const { name, value } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleImage = (e) => {
    const { name, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files[0],
    }));
  };

  const handleItemChange = (e) => {
    const { name, value } = e.target;
    setItem((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fillTheInputError = async (icon, description) => {
    await Swal.fire({
      title: description,
      icon: icon,
    });
  };

  const addItemList = () => {
    if (!item.item_name || !item.item_group) {
      fillTheInputError("warning", "Please fill in all details");
      return;
    }
    setItemList((prev) => [...prev, { ...item }]);
    clearItems();
  };

  const clearItems = () => {
    setItem({
      item_name: "",
      item_unit: "",
      item_group: "",
      item_desc: "",
      item_gst: "",
      item_qty: "",
      item_rate: "",
    });
  };

  const clearForm = () => {
    setFormData({
      factory: "",
      party: "",
      entryDate: "", //voucher Date
      voucherNo: "",
      challanDate: "",
      challanNo: "",
      destination: "",
      dispathThrough: "",
      deliveryTerms: "",
      narration: "",
      invoice_img: "",
    });
  };

  const deleteRow = (indexToDelete) => {
    const newArr = itemList.filter((item, index) => index !== indexToDelete);
    setItemList(newArr);
  };

  const deleteAll = () => {
    setItemList([]);
  };

  const resetAll = () => {
    clearItems();
    clearForm();
    deleteAll();
  };


  const renderPreview = (filePath, altText, labelText) => {
  if (!filePath) return null;

  const fullUrl = `${process.env.REACT_APP_IMG_URI}/${filePath}`;
  const isPDF = filePath.toLowerCase().endsWith(".pdf");

  return (
    <div style={{ width: 100 }}>
      {isPDF ? (
        <a
          href={fullUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline text-sm"
        >
          {labelText || "View PDF"}
        </a>
      ) : (
        <ModalImage
          small={fullUrl}
          large={fullUrl}
          alt={altText}
        />
      )}
    </div>
  );
};


  const payload = {
    ...formData,
    items: itemList,
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSend = new FormData();

    formDataToSend.append("factory", formData.factory);
    formDataToSend.append("party", formData.party);
    formDataToSend.append("entryDate", formData.entryDate);
    formDataToSend.append("voucherNo", formData.voucherNo);
    formDataToSend.append("challanDate", formData.challanDate);
    formDataToSend.append("challanNo", formData.challanNo);
    formDataToSend.append("destination", formData.destination);
    formDataToSend.append("dispathThrough", formData.dispathThrough);
    formDataToSend.append("deliveryTerms", formData.deliveryTerms);
    formDataToSend.append("narration", formData.narration);

    if (formData.invoice_img) {
      formDataToSend.append("invoice_img", formData.invoice_img);
    }

    // items → send as array fields
    itemList.forEach((item, index) => {
      for (const key in item) {
        formDataToSend.append(`items[${index}][${key}]`, item[key]);
      }
    });

    // Check if there are no items in the list
    if (itemList.length === 0) {
      fillTheInputError("warning", "Please Add Items");
      return;
    }

    try {
        if (editData !== null) {
            await api.patch(`/material-in-out/update/${editDataId}`, payload);
        } else {
            // await api.post(`/material-in-out/add`, payload);
            const res = await api.post(`/material-in-out/add`, formDataToSend, {
            headers: { "Content-Type": "multipart/form-data" },
            });
            if (res.data.success) {
                fillTheInputError("success", "Data saved successfully!");
                } else {
                fillTheInputError("error", "Failed to save data!");
                }
        }
      navigate(`/material-in-out`);
    } catch (error) {
      console.error("Submission failed:", error);
      fillTheInputError("error", "Something went wrong");
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center w-[98%] py-3 px-5 bg-white shadow-lg rounded-lg my-5 ml-6">
        <h1 className="text-2xl font-bold text-gray-800">Material In/Out</h1>
        <button
          className="bg-purple-500 text-white py-2 px-6 rounded-lg hover:bg-purple-600 focus:outline-none"
          onClick={() => {
            navigate("/material-in-out");
          }}
        >
          Back
        </button>
      </div>
      <div className="w-[98%] p-6 bg-white shadow-lg rounded-lg mt-2 ml-6">
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-6 gap-x-6 gap-y-3">
            <div>
              <label className="block text-base font-medium text-gray-800 mb-2">
                Choose Factory Location <span className="text-red-500">*</span>
              </label>

              <Select
                options={facLocation}
                isDisabled={
                  !(UserName === "Admin" || UserName === "Sameer Khan")
                }
                value={
                  formData.factory
                    ? facLocation.find(
                        (option) => option.value === formData.factory
                      )
                    : null
                }
                name="factory"
                placeholder={
                  UserName === "Admin" || UserName === "Sameer Khan"
                    ? "SELECT"
                    : `${facName}`
                }
                onChange={handleChange}
                isClearable
              />
            </div>

            <div>
              <label className="block text-base font-medium text-gray-800 mb-2">
                Choose Party Name <span className="text-red-500">*</span>
              </label>

              <Select
                options={vendorList}
                value={
                  formData.party
                    ? vendorList.find(
                        (option) => option.value === formData.party
                      )
                    : null
                }
                name="party"
                placeholder="Select Party"
                onChange={handleChange}
              />
            </div>

            {/* Voucher No */}
            <div>
              <label className="block text-base font-medium text-gray-800 mb-2">
                Voucher No. <span className="text-red-500">*</span>
              </label>
              <input
                type="input"
                name="voucherNo"
                placeholder="Enter Voucher No."
                value={formData.voucherNo}
                onChange={handleChange}
                className="w-full border rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
            {/* {Voucher Date} */}
            <div>
              <label className="block text-base font-medium text-gray-800 mb-2">
                Entry Date <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                name="entryDate"
                value={formData.entryDate}
                onChange={handleChange}
                className="w-full border rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
            {/* Challan no. */}
            <div>
              <label className="block text-base font-medium text-gray-800 mb-2">
                Challan No. <span className="text-red-500">*</span>
              </label>
              <input
                type="input"
                name="challanNo"
                placeholder="Enter Voucher No."
                value={formData.challanNo}
                onChange={handleChange}
                className="w-full border rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>

            {/* Challan Date */}
            <div>
              <label className="block text-base font-medium text-gray-800 mb-2">
                Challan Date <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                name="challanDate"
                value={formData.challanDate}
                onChange={handleChange}
                className="w-full border rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
            {/* Destination */}
            <div>
              <label className="block text-base font-medium text-gray-800 mb-2">
                Destination <span className="text-red-500">*</span>
              </label>
              <input
                type="input"
                name="destination"
                placeholder="Enter Destination"
                value={formData.destination}
                onChange={handleChange}
                className="w-full border rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
            {/* Dispatched through */}
            <div>
              <label className="block text-base font-medium text-gray-800 mb-2">
                Dispatched through <span className="text-red-500">*</span>
              </label>
              <input
                type="input"
                name="dispathThrough"
                placeholder="Enter Dispatched through "
                value={formData.dispathThrough}
                onChange={handleChange}
                className="w-full border rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>

            {/* Terms of Delivery */}
            <div>
              <label className="block text-base font-medium text-gray-800 mb-2">
                Terms of Delivery <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="deliveryTerms"
                value={formData.deliveryTerms}
                onChange={handleChange}
                className="w-full h-20 border rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
            {/* Narration */}
            <div>
              <label className="block text-base font-medium text-gray-800 mb-2">
                Narration <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="narration"
                value={formData.narration}
                onChange={handleChange}
                className="w-full  h-20 border rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
            {/* Invoice Image */}
            <div className="flex flex-col">
              <label className="mb-2 font-semibold text-gray-700">
                Invoice Image <span className="text-red-500">*</span>
              </label>
              <input
                type="file"
                name="invoice_img"
                onChange={handleImage}
                className="input-style"
              />
             {editData && renderPreview(editData.invoice_img, "Invoice Image", "View Invoice")}
  
            </div>
          </div>

          {/* second layer of the form start here */}

          <div className="flex flex-col mx-auto gap-2 mt-10 justify-center items-center">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-2 w-full">
              <Select
                placeholder={
                  item.item_group.split("_")[1] || "Select Category..."
                }
                value={item.item_name}
                options={itemGroups}
                onChange={(e) =>
                  setItem((prev) => ({ ...prev, item_group: e.value }))
                }
                styles={{
                  menuList: () => ({
                    overflowY: "scroll",
                    maxHeight: "200px",
                  }),
                  input: (baseStyles) => ({
                    ...baseStyles,
                    width: "180px",
                  }),
                  placeholder: (baseStyles) => ({
                    ...baseStyles,
                    color: item.item_group ? "black" : "gray",
                  }),
                }}
              />

              <div>
                <Select
                  options={dropItem}
                  placeholder={
                    (item.item_name?.split("_")[1]?.length > 15
                      ? `${item.item_name.split("_")[1]?.slice(0, 20)}....`
                      : item.item_name.split("_")[1]) || "Select Item..."
                  }
                  value={item.item_name}
                  onChange={(e) => {
                    setItem((prev) => ({ ...prev, item_unit: e.unit }));
                    return setItem((prev) => ({ ...prev, item_name: e.value }));
                  }}
                  styles={{
                    menuList: () => ({
                      overflowY: "scroll",
                      maxHeight: "200px",
                    }),
                    input: (baseStyles) => ({
                      ...baseStyles,
                      width: "180px",
                    }),
                    placeholder: (baseStyles) => ({
                      ...baseStyles,
                      color: item.item_name ? "black" : "gray",
                    }),
                  }}
                />{" "}
                <span
                  style={{
                    display: "inline",
                    fontSize: "12px",
                    color: "green",
                  }}
                >
                  {item.item_unit}{" "}
                </span>
              </div>
              <input
                type="number"
                name="item_gst"
                id="gst"
                placeholder="GST %"
                className=" rounded-md border-0 px-4 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                value={item.item_gst}
                onChange={handleItemChange}
              />
              <input
                type="number"
                name="item_qty"
                placeholder="Qty"
                className=" rounded-md border-0 py-1.5 px-4 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                value={item.item_qty}
                onChange={handleItemChange}
              />
              <input
                type="number"
                name="item_rate"
                placeholder="Rate"
                className=" rounded-md border-0 py-1.5 px-4 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                value={item.item_rate}
                onChange={handleItemChange}
              />

              <input
                type="text"
                name="item_desc"
                className=" rounded-md border-0 px-4 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                placeholder="Item Description"
                value={item.item_desc}
                onChange={handleItemChange}
              />
              <div className="flex justify-center items-center">
                <div
                  className="rounded bg-violet-600 hover:bg-violet-700 text-white font-bold p-1.5 px-3 cursor-pointer"
                  onClick={addItemList}
                >
                  <span>+ ADD</span>
                </div>
              </div>
            </div>
          </div>

          {itemList.length > 0 ? (
            <>
              <div className="w-full m-auto mt-20 flex flex-col justify-center items-center rounded bg-[#fdfdfdfd] border">
                <div className="font-bold text-lg">
                  Material in/Out Item List
                </div>
                <div className=" container mx-auto pt-4">
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white border border-gray-200">
                      <thead>
                        <tr>
                          <th className="px-4 py-2 border">Item Name</th>
                          <th className="px-4 py-2 border">Item Category</th>
                          <th className="px-4 py-2 border">Item GST</th>
                          <th className="px-4 py-2 border">Item Qty</th>
                          <th className="px-4 py-2 border">Item Rate</th>
                          <th className="px-4 py-2 border">Item Description</th>
                          <th className="px-4 py-2 border flex justify-evenly">
                            Delete{" "}
                            <Trash2
                              className="transition-colors text-white ease-in bg-red-600 hover:bg-red-700 p-1 rounded shadow cursor-pointer"
                              onClick={deleteAll}
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {itemList.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td className={`px-4 py-2 border text-center`}>
                                {item.item_name.split("_")[1]}
                              </td>
                              <td className={`px-4 py-2 border text-center`}>
                                {item.item_group.split("_")[1]}
                              </td>
                              <td className={`px-4 py-2 border text-center`}>
                                {item.item_gst}
                              </td>
                              <td className={`px-4 py-2 border text-center`}>
                                {item.item_qty}
                              </td>
                              <td className={`px-4 py-2 border text-center`}>
                                {item.item_rate}
                              </td>
                              <td className={`px-4 py-2 border text-center`}>
                                {item.item_desc}
                              </td>
                              <td
                                className={`px-4 py-2 border flex justify-center`}
                              >
                                <div
                                  className="transition-colors ease-in bg-red-600 hover:bg-red-700 p-1 rounded shadow cursor-pointer"
                                  onClick={() => deleteRow(index)}
                                >
                                  <Trash2
                                    className="text-center"
                                    color="white"
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          {!loading && (
            <div className="flex justify-center items-center gap-3 mt-8">
              <div
                className="rounded bg-red-600 hover:bg-red-700 text-white font-bold p-1 w-[10%] cursor-pointer text-center"
                onClick={resetAll}
              >
                <span>Reset</span>
              </div>
              <button
                type="submit"
                className="rounded bg-green-600 hover:bg-green-700 text-white font-bold p-1 w-[10%] cursor-pointer text-center"
              >
                {editData !== null ? "Update" : "Submit"}
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default MaterialForm;
